import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

export interface Client {
  id?: number;
  firstName: string;
  lastName: string;
}

interface AddClientResponse {
  newConsumerId?: number;
  clientId?: number;
}

const addClient = (client: Client): Promise<AddClientResponse> => {
  const body = client.id
    ? {
        consumerId: client.id,
        cloneFirstName: client.firstName,
        cloneLastName: client.lastName,
      }
    : {
        FirstName: client.firstName,
        LastName: client.lastName,
      };

  return authFetch(`/Adviser/Adviser/${client.id ? 'CloneClient' : 'AddNewClient'}`, {
    method: 'POST',
    ...httpBodyOptions(body),
  });
};

export const useAddClientMutation = () => {
  return useMutation(addClient);
};
